import React from "react";
import styles from "./ServicingCtaCard.module.scss";
import { Button } from "components/ui/button/Button";
import redirect from "assets/images/v2/redirect.svg";

interface Props {
    onClick: () => void;
}

const ServicingCtaCard: React.FC<Props> = ({ onClick }) => {
    return (
        <div className={styles.card}>
            <div className={styles.cardContent}>
                <p className={styles.description}>
                    Easily manage your mortgage details, from payments to statements, all in one place.
                </p>
                <Button
                    className={styles.ctaButton}
                    onClick={onClick}>
                    <span>Manage My Mortgage</span>
                    <img
                        className={styles.redirectSvg}
                        alt="redirect"
                        aria-hidden="true"
                        src={redirect}
                    />
                </Button>
            </div>
        </div>
    );
};

export default ServicingCtaCard;